import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useCustomAccordion = (itemsIds: string[]) => {
  const { t } = useTranslation()
  const [expandedItems, setExpandedItems] = useState<string[]>([])

  const allExpanded = expandedItems.length === itemsIds.length

  const toggleAll = () => {
    setExpandedItems(allExpanded ? [] : [...itemsIds])
  }

  const toggleAccordion = (itemId: string, isExpanded: boolean) => {
    setExpandedItems(prev => (isExpanded ? [...prev, itemId] : prev.filter(id => id !== itemId)))
  }

  const handleAccordionChange = (itemId: string) => (value: string | string[] | null) => {
    const valueArray = Array.isArray(value) ? value : value ? [value] : []
    toggleAccordion(itemId, valueArray.includes(itemId))
  }

  const getAccordionValue = (itemId: string) => {
    return expandedItems.includes(itemId) ? [itemId] : []
  }

  const label = t(`typography.${allExpanded ? 'collapseAll' : 'expandAll'}`)

  return { toggleAll, handleAccordionChange, getAccordionValue, label }
}
